import { render } from "./addTag.vue?vue&type=template&id=296c31d3&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"

import "./addTag.vue?vue&type=style&index=0&id=296c31d3&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c31d3"]])

export default __exports__